export default [
	{
		Name: "Afghanistan",
		Value: "AF",
		Selected: false,
	},
	{
		Name: "Albania",
		Value: "AL",
		Selected: false,
	},
	{
		Name: "Algeria",
		Value: "DZ",
		Selected: false,
	},
	{
		Name: "American Samoa",
		Value: "AS",
		Selected: false,
	},
	{
		Name: "Andorra",
		Value: "AD",
		Selected: false,
	},
	{
		Name: "Angola",
		Value: "AO",
		Selected: false,
	},
	{
		Name: "Anguilla",
		Value: "AI",
		Selected: false,
	},
	{
		Name: "Antarctica",
		Value: "AQ",
		Selected: false,
	},
	{
		Name: "Antigua and Barbuda",
		Value: "AG",
		Selected: false,
	},
	{
		Name: "Argentina",
		Value: "AR",
		Selected: false,
	},
	{
		Name: "Armenia",
		Value: "AM",
		Selected: false,
	},
	{
		Name: "Aruba",
		Value: "AW",
		Selected: false,
	},
	{
		Name: "Australia",
		Value: "AU",
		Selected: false,
	},
	{
		Name: "Austria",
		Value: "AT",
		Selected: false,
	},
	{
		Name: "Azerbaijan",
		Value: "AZ",
		Selected: false,
	},
	{
		Name: "Bahamas",
		Value: "BS",
		Selected: false,
	},
	{
		Name: "Bahrain",
		Value: "BH",
		Selected: false,
	},
	{
		Name: "Bangladesh",
		Value: "BD",
		Selected: false,
	},
	{
		Name: "Barbados",
		Value: "BB",
		Selected: false,
	},
	{
		Name: "Belarus",
		Value: "BY",
		Selected: false,
	},
	{
		Name: "Belgium",
		Value: "BE",
		Selected: false,
	},
	{
		Name: "Belize",
		Value: "BZ",
		Selected: false,
	},
	{
		Name: "Benin",
		Value: "BJ",
		Selected: false,
	},
	{
		Name: "Bermuda",
		Value: "BM",
		Selected: false,
	},
	{
		Name: "Bhutan",
		Value: "BT",
		Selected: false,
	},
	{
		Name: "Bolivia",
		Value: "BO",
		Selected: false,
	},
	{
		Name: "Bosnia and Herzegovina",
		Value: "BA",
		Selected: false,
	},
	{
		Name: "Botswana",
		Value: "BW",
		Selected: false,
	},
	{
		Name: "Bouvet Island",
		Value: "BV",
		Selected: false,
	},
	{
		Name: "Brazil",
		Value: "BR",
		Selected: false,
	},
	{
		Name: "British Indian Ocean Territory",
		Value: "IO",
		Selected: false,
	},
	{
		Name: "British Virgin Islands",
		Value: "VG",
		Selected: false,
	},
	{
		Name: "Brunei Darussalam",
		Value: "BN",
		Selected: false,
	},
	{
		Name: "Bulgaria",
		Value: "BG",
		Selected: false,
	},
	{
		Name: "Burkina Faso",
		Value: "BF",
		Selected: false,
	},
	{
		Name: "Burundi",
		Value: "BI",
		Selected: false,
	},
	{
		Name: "Cambodia",
		Value: "KH",
		Selected: false,
	},
	{
		Name: "Cameroon",
		Value: "CM",
		Selected: false,
	},
	{
		Name: "Canada",
		Value: "CA",
		Selected: false,
	},
	{
		Name: "Cape Verde",
		Value: "CV",
		Selected: false,
	},
	{
		Name: "Cayman Islands",
		Value: "KY",
		Selected: false,
	},
	{
		Name: "Central African Republic",
		Value: "CF",
		Selected: false,
	},
	{
		Name: "Chad",
		Value: "TD",
		Selected: false,
	},
	{
		Name: "Chile",
		Value: "CL",
		Selected: false,
	},
	{
		Name: "China",
		Value: "CN",
		Selected: false,
	},
	{
		Name: "Christmas Island",
		Value: "CX",
		Selected: false,
	},
	{
		Name: "Cocos",
		Value: "CC",
		Selected: false,
	},
	{
		Name: "Colombia",
		Value: "CO",
		Selected: false,
	},
	{
		Name: "Comoros",
		Value: "KM",
		Selected: false,
	},
	{
		Name: "Congo - Brazzaville",
		Value: "CG",
		Selected: false,
	},
	{
		Name: "Congo-Kinshasa",
		Value: "CD",
		Selected: false,
	},
	{
		Name: "Cook Islands",
		Value: "CK",
		Selected: false,
	},
	{
		Name: "Costa Rica",
		Value: "CR",
		Selected: false,
	},
	{
		Name: "Croatia",
		Value: "HR",
		Selected: false,
	},
	{
		Name: "Cuba",
		Value: "CU",
		Selected: false,
	},
	{
		Name: "Cyprus",
		Value: "CY",
		Selected: false,
	},
	{
		Name: "Czech Republic",
		Value: "CZ",
		Selected: false,
	},
	{
		Name: "Denmark",
		Value: "DK",
		Selected: false,
	},
	{
		Name: "Djibouti",
		Value: "DJ",
		Selected: false,
	},
	{
		Name: "Dominica",
		Value: "DM",
		Selected: false,
	},
	{
		Name: "Dominican Republic",
		Value: "DO",
		Selected: false,
	},
	{
		Name: "East Timor",
		Value: "TP",
		Selected: false,
	},
	{
		Name: "Ecuador",
		Value: "EC",
		Selected: false,
	},
	{
		Name: "Egypt",
		Value: "EG",
		Selected: false,
	},
	{
		Name: "El Salvador",
		Value: "SV",
		Selected: false,
	},
	{
		Name: "Equatorial Guinea",
		Value: "GQ",
		Selected: false,
	},
	{
		Name: "Eritrea",
		Value: "ER",
		Selected: false,
	},
	{
		Name: "Estonia",
		Value: "EE",
		Selected: false,
	},
	{
		Name: "Ethiopia",
		Value: "ET",
		Selected: false,
	},
	{
		Name: "Falkland Islands",
		Value: "FK",
		Selected: false,
	},
	{
		Name: "Faroe Islands",
		Value: "FO",
		Selected: false,
	},
	{
		Name: "Fiji",
		Value: "FJ",
		Selected: false,
	},
	{
		Name: "Finland",
		Value: "FI",
		Selected: false,
	},
	{
		Name: "France",
		Value: "FR",
		Selected: false,
	},
	{
		Name: "French Guiana",
		Value: "GF",
		Selected: false,
	},
	{
		Name: "French Polynesia",
		Value: "PF",
		Selected: false,
	},
	{
		Name: "French Southern Territories",
		Value: "TF",
		Selected: false,
	},
	{
		Name: "Gabon",
		Value: "GA",
		Selected: false,
	},
	{
		Name: "Gambia",
		Value: "GM",
		Selected: false,
	},
	{
		Name: "Georgia",
		Value: "GE",
		Selected: false,
	},
	{
		Name: "Germany",
		Value: "DE",
		Selected: false,
	},
	{
		Name: "Ghana",
		Value: "GH",
		Selected: false,
	},
	{
		Name: "Gibraltar",
		Value: "GI",
		Selected: false,
	},
	{
		Name: "Greece",
		Value: "GR",
		Selected: false,
	},
	{
		Name: "Greenland",
		Value: "GL",
		Selected: false,
	},
	{
		Name: "Grenada",
		Value: "GD",
		Selected: false,
	},
	{
		Name: "Guadeloupe",
		Value: "GP",
		Selected: false,
	},
	{
		Name: "Guam",
		Value: "GU",
		Selected: false,
	},
	{
		Name: "Guatemala",
		Value: "GT",
		Selected: false,
	},
	{
		Name: "Guinea",
		Value: "GN",
		Selected: false,
	},
	{
		Name: "Guinea-Bissau",
		Value: "GW",
		Selected: false,
	},
	{
		Name: "Guyana",
		Value: "GY",
		Selected: false,
	},
	{
		Name: "Haiti",
		Value: "HT",
		Selected: false,
	},
	{
		Name: "Heard and McDonald Islands",
		Value: "HM",
		Selected: false,
	},
	{
		Name: "Honduras",
		Value: "HN",
		Selected: false,
	},
	{
		Name: "Hong Kong",
		Value: "HK",
		Selected: false,
	},
	{
		Name: "Hungary",
		Value: "HU",
		Selected: false,
	},
	{
		Name: "Iceland",
		Value: "IS",
		Selected: false,
	},
	{
		Name: "India",
		Value: "IN",
		Selected: false,
	},
	{
		Name: "Indonesia",
		Value: "ID",
		Selected: false,
	},
	{
		Name: "Iran",
		Value: "IR",
		Selected: false,
	},
	{
		Name: "Iraq",
		Value: "IQ",
		Selected: false,
	},
	{
		Name: "Ireland",
		Value: "IE",
		Selected: false,
	},
	{
		Name: "Israel",
		Value: "IL",
		Selected: false,
	},
	{
		Name: "Italy",
		Value: "IT",
		Selected: false,
	},
	{
		Name: "Ivory Coast",
		Value: "CI",
		Selected: false,
	},
	{
		Name: "Jamaica",
		Value: "JM",
		Selected: false,
	},
	{
		Name: "Japan",
		Value: "JP",
		Selected: false,
	},
	{
		Name: "Jordan",
		Value: "JO",
		Selected: false,
	},
	{
		Name: "Kazakhstan",
		Value: "KZ",
		Selected: false,
	},
	{
		Name: "Kenya",
		Value: "KE",
		Selected: false,
	},
	{
		Name: "Kiribati",
		Value: "KI",
		Selected: false,
	},
	{
		Name: "Kosovo",
		Value: "XK",
		Selected: false,
	},
	{
		Name: "Kuwait",
		Value: "KW",
		Selected: false,
	},
	{
		Name: "Kyrgyzstan",
		Value: "KG",
		Selected: false,
	},
	{
		Name: "Laos",
		Value: "LA",
		Selected: false,
	},
	{
		Name: "Latvia",
		Value: "LV",
		Selected: false,
	},
	{
		Name: "Lebanon",
		Value: "LB",
		Selected: false,
	},
	{
		Name: "Lesotho",
		Value: "LS",
		Selected: false,
	},
	{
		Name: "Liberia",
		Value: "LR",
		Selected: false,
	},
	{
		Name: "Libya",
		Value: "LY",
		Selected: false,
	},
	{
		Name: "Liechtenstein",
		Value: "LI",
		Selected: false,
	},
	{
		Name: "Lithuania",
		Value: "LT",
		Selected: false,
	},
	{
		Name: "Luxembourg",
		Value: "LU",
		Selected: false,
	},
	{
		Name: "Macau",
		Value: "MO",
		Selected: false,
	},
	{
		Name: "Macedonia",
		Value: "MK",
		Selected: false,
	},
	{
		Name: "Madagascar",
		Value: "MG",
		Selected: false,
	},
	{
		Name: "Malawi",
		Value: "MW",
		Selected: false,
	},
	{
		Name: "Malaysia",
		Value: "MY",
		Selected: false,
	},
	{
		Name: "Maldives",
		Value: "MV",
		Selected: false,
	},
	{
		Name: "Mali",
		Value: "ML",
		Selected: false,
	},
	{
		Name: "Malta",
		Value: "MT",
		Selected: false,
	},
	{
		Name: "Marshall Islands",
		Value: "MH",
		Selected: false,
	},
	{
		Name: "Martinique",
		Value: "MQ",
		Selected: false,
	},
	{
		Name: "Mauritania",
		Value: "MR",
		Selected: false,
	},
	{
		Name: "Mauritius",
		Value: "MU",
		Selected: false,
	},
	{
		Name: "Mayotte",
		Value: "YT",
		Selected: false,
	},
	{
		Name: "Mexico",
		Value: "MX",
		Selected: false,
	},
	{
		Name: "Micronesia",
		Value: "FM",
		Selected: false,
	},
	{
		Name: "Moldova",
		Value: "MD",
		Selected: false,
	},
	{
		Name: "Monaco",
		Value: "MC",
		Selected: false,
	},
	{
		Name: "Mongolia",
		Value: "MN",
		Selected: false,
	},
	{
		Name: "Montenegro",
		Value: "ME",
		Selected: false,
	},
	{
		Name: "Montserrat",
		Value: "MS",
		Selected: false,
	},
	{
		Name: "Morocco",
		Value: "MA",
		Selected: false,
	},
	{
		Name: "Mozambique",
		Value: "MZ",
		Selected: false,
	},
	{
		Name: "Myanmar",
		Value: "MM",
		Selected: false,
	},
	{
		Name: "Namibia",
		Value: "NA",
		Selected: false,
	},
	{
		Name: "Nauru",
		Value: "NR",
		Selected: false,
	},
	{
		Name: "Nepal",
		Value: "NP",
		Selected: false,
	},
	{
		Name: "Netherlands",
		Value: "NL",
		Selected: false,
	},
	{
		Name: "Netherlands Antilles",
		Value: "AN",
		Selected: false,
	},
	{
		Name: "New Caledonia",
		Value: "NC",
		Selected: false,
	},
	{
		Name: "New Zealand",
		Value: "NZ",
		Selected: false,
	},
	{
		Name: "Nicaragua",
		Value: "NI",
		Selected: false,
	},
	{
		Name: "Niger",
		Value: "NE",
		Selected: false,
	},
	{
		Name: "Nigeria",
		Value: "NG",
		Selected: false,
	},
	{
		Name: "Niue",
		Value: "NU",
		Selected: false,
	},
	{
		Name: "Norfolk Island",
		Value: "NF",
		Selected: false,
	},
	{
		Name: "North Korea",
		Value: "KP",
		Selected: false,
	},
	{
		Name: "Northern Mariana Islands",
		Value: "MP",
		Selected: false,
	},
	{
		Name: "Norway",
		Value: "NO",
		Selected: false,
	},
	{
		Name: "Oman",
		Value: "OM",
		Selected: false,
	},
	{
		Name: "Pakistan",
		Value: "PK",
		Selected: false,
	},
	{
		Name: "Palau",
		Value: "PW",
		Selected: false,
	},
	{
		Name: "Panama",
		Value: "PA",
		Selected: false,
	},
	{
		Name: "Papua New Guinea",
		Value: "PG",
		Selected: false,
	},
	{
		Name: "Paraguay",
		Value: "PY",
		Selected: false,
	},
	{
		Name: "Peru",
		Value: "PE",
		Selected: false,
	},
	{
		Name: "Philippines",
		Value: "PH",
		Selected: false,
	},
	{
		Name: "Pitcairn",
		Value: "PN",
		Selected: false,
	},
	{
		Name: "Poland",
		Value: "PL",
		Selected: false,
	},
	{
		Name: "Portugal",
		Value: "PT",
		Selected: false,
	},
	{
		Name: "Puerto Rico",
		Value: "PR",
		Selected: false,
	},
	{
		Name: "Qatar",
		Value: "QA",
		Selected: false,
	},
	{
		Name: "Reunion",
		Value: "RE",
		Selected: false,
	},
	{
		Name: "Romania",
		Value: "RO",
		Selected: false,
	},
	{
		Name: "Russian Federation",
		Value: "RU",
		Selected: false,
	},
	{
		Name: "Rwanda",
		Value: "RW",
		Selected: false,
	},
	{
		Name: "S. Georgia and S. Sandwich Islands",
		Value: "GS",
		Selected: false,
	},
	{
		Name: "Saint Kitts and Nevis",
		Value: "KN",
		Selected: false,
	},
	{
		Name: "Saint Lucia",
		Value: "LC",
		Selected: false,
	},
	{
		Name: "Saint Vincent and The Grenadines",
		Value: "VC",
		Selected: false,
	},
	{
		Name: "Samoa",
		Value: "WS",
		Selected: false,
	},
	{
		Name: "San Marino",
		Value: "SM",
		Selected: false,
	},
	{
		Name: "Sao Tome and Principe",
		Value: "ST",
		Selected: false,
	},
	{
		Name: "Saudi Arabia",
		Value: "SA",
		Selected: false,
	},
	{
		Name: "Senegal",
		Value: "SN",
		Selected: false,
	},
	{
		Name: "Serbia",
		Value: "RS",
		Selected: false,
	},
	{
		Name: "Seychelles",
		Value: "SC",
		Selected: false,
	},
	{
		Name: "Sierra Leone",
		Value: "SL",
		Selected: false,
	},
	{
		Name: "Singapore",
		Value: "SG",
		Selected: false,
	},
	{
		Name: "Slovakia",
		Value: "SK",
		Selected: false,
	},
	{
		Name: "Slovenia",
		Value: "SI",
		Selected: false,
	},
	{
		Name: "Solomon Islands",
		Value: "SB",
		Selected: false,
	},
	{
		Name: "Somalia",
		Value: "SO",
		Selected: false,
	},
	{
		Name: "South Africa",
		Value: "ZA",
		Selected: false,
	},
	{
		Name: "South Korea",
		Value: "KR",
		Selected: false,
	},
	{
		Name: "Soviet Union",
		Value: "SU",
		Selected: false,
	},
	{
		Name: "Spain",
		Value: "ES",
		Selected: false,
	},
	{
		Name: "Sri Lanka",
		Value: "LK",
		Selected: false,
	},
	{
		Name: "St. Helena",
		Value: "SH",
		Selected: false,
	},
	{
		Name: "St. Pierre and Miquelon",
		Value: "PM",
		Selected: false,
	},
	{
		Name: "Sudan",
		Value: "SD",
		Selected: false,
	},
	{
		Name: "Suriname",
		Value: "SR",
		Selected: false,
	},
	{
		Name: "Svalbard and Jan Mayen Islands",
		Value: "SJ",
		Selected: false,
	},
	{
		Name: "Swaziland",
		Value: "SZ",
		Selected: false,
	},
	{
		Name: "Sweden",
		Value: "SE",
		Selected: false,
	},
	{
		Name: "Switzerland",
		Value: "CH",
		Selected: true,
	},
	{
		Name: "Syria",
		Value: "SY",
		Selected: false,
	},
	{
		Name: "Taiwan",
		Value: "TW",
		Selected: false,
	},
	{
		Name: "Tajikistan",
		Value: "TJ",
		Selected: false,
	},
	{
		Name: "Tanzania",
		Value: "TZ",
		Selected: false,
	},
	{
		Name: "Thailand",
		Value: "TH",
		Selected: false,
	},
	{
		Name: "Timor-Leste",
		Value: "TL",
		Selected: false,
	},
	{
		Name: "Togo",
		Value: "TG",
		Selected: false,
	},
	{
		Name: "Tokelau",
		Value: "TK",
		Selected: false,
	},
	{
		Name: "Tonga",
		Value: "TO",
		Selected: false,
	},
	{
		Name: "Trinidad and Tobago",
		Value: "TT",
		Selected: false,
	},
	{
		Name: "Tunisia",
		Value: "TN",
		Selected: false,
	},
	{
		Name: "Turkey",
		Value: "TR",
		Selected: false,
	},
	{
		Name: "Turkmenistan",
		Value: "TM",
		Selected: false,
	},
	{
		Name: "Turks and Caicos Islands",
		Value: "TC",
		Selected: false,
	},
	{
		Name: "Tuvalu",
		Value: "TV",
		Selected: false,
	},
	{
		Name: "Uganda",
		Value: "UG",
		Selected: false,
	},
	{
		Name: "Ukraine",
		Value: "UA",
		Selected: false,
	},
	{
		Name: "United Arab Emirates",
		Value: "AE",
		Selected: false,
	},
	{
		Name: "United Kingdom",
		Value: "GB",
		Selected: false,
	},
	{
		Name: "United States",
		Value: "US",
		Selected: false,
	},
	{
		Name: "Uruguay",
		Value: "UY",
		Selected: false,
	},
	{
		Name: "US Minor Outlying Islands",
		Value: "UM",
		Selected: false,
	},
	{
		Name: "US Virgin Islands",
		Value: "VI",
		Selected: false,
	},
	{
		Name: "Uzbekistan",
		Value: "UZ",
		Selected: false,
	},
	{
		Name: "Vanuatu",
		Value: "VU",
		Selected: false,
	},
	{
		Name: "Venezuela",
		Value: "VE",
		Selected: false,
	},
	{
		Name: "Viet Nam",
		Value: "VN",
		Selected: false,
	},
	{
		Name: "Wallis and Futuna Islands",
		Value: "WF",
		Selected: false,
	},
	{
		Name: "Western Sahara",
		Value: "EH",
		Selected: false,
	},
	{
		Name: "Yemen",
		Value: "YE",
		Selected: false,
	},
	{
		Name: "Yugoslavia",
		Value: "YU",
		Selected: false,
	},
	{
		Name: "Zaire",
		Value: "ZR",
		Selected: false,
	},
	{
		Name: "Zambia",
		Value: "ZM",
		Selected: false,
	},
	{
		Name: "Zimbabwe",
		Value: "ZW",
		Selected: false,
	},
];
